import React, { Component } from "react";
import { Paper, Grid } from "@material-ui/core";
import { connect } from "react-redux";
import {
    getUsers,
    getReportTypes,
    setToDateFilter,
    setFromDateFilter
} from "./actions";
import { Bar } from "react-chartjs-2";
import { hot } from "react-hot-loader";
class ReportTotalBarChart extends Component {
    constructor(props) {
        super(props);
        props.getUsers();
        props.getReportTypes();
    }
    componentDidUpdate(nextProps, nextState) {
        if (nextProps.toDate !== this.props.toDate) {
            this.props.setToDateFilter(this.props.toDate);
        }
        if (nextProps.fromDate !== this.props.fromDate) {
            this.props.setFromDateFilter(this.props.fromDate);
        }
    }
    render() {
        const { sm, md, lg } = this.props;
        return (
            <Grid item sm={sm} md={md} lg={lg}>
                <Paper style={{ paddingTop: 10, height: "100%" }}>
                    {this.props.data && (
                        <Bar
                            height={400}
                            options={{
                                maintainAspectRatio: false,
                                scales: {
                                    yAxes: [
                                        {
                                            ticks: {
                                                beginAtZero: true
                                            }
                                        }
                                    ]
                                }
                            }}
                            data={this.props.data}
                        />
                    )}
                </Paper>
            </Grid>
        );
    }
}

export default hot(module)(
    connect(
        (store, props) => {
            const { selectors } = props;
            const { selectReports } = selectors;

            return {
                data: selectReports(store)
            };
        },
        { getUsers, getReportTypes, setToDateFilter, setFromDateFilter }
    )(ReportTotalBarChart)
);
